module.exports = __webpack_public_path__ + "img/production_banner_m.84ad1484.png";